module.exports = __webpack_public_path__ + "img/screen-1.7587a70c.jpg";